import {
    Alert,
    Button, CircularProgress,
    Container,
    Divider, FormControl,
    FormControlLabel,
    FormLabel,
    Grid, IconButton, InputAdornment, InputLabel,
    Link, ListItemIcon, ListItemText, MenuItem, Select,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import React, {ChangeEvent, useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {useUserLoginContext} from "../Contexts/UserContext";
import {LoginResultType, useLoginMutation} from "../generated/graphql";
import {useBasketContext} from "../Contexts/BasketContext";
//import {theatres} from "../theatres";
import {useSiteDataContext} from "../Contexts/SiteDataContext";
import {Visibility, VisibilityOff} from "@mui/icons-material";

interface LoginParams {
    username: string
    password: string
    role: string
};

function InternalLoginPage() {
    const navigate = useNavigate();
    const setUser = useUserLoginContext();
    const basket = useBasketContext();
    const siteData = useSiteDataContext();
    const page = siteData.pages.internalLogin;
    const [loginResult,doLogin] = useLoginMutation();
    const [state,setState] = useState<LoginParams>({username:'',password:'',role:''});
    const [showPassword,setShowPassword] = useState(false);
    const [error,setError] = useState('');
    useEffect(()=>{
        siteData.setInternal(true);
    },[]);
    function onChange(evt) {
        var target = evt.target as HTMLInputElement;
        setState((oldState)=>{
            var v = {...oldState};
            v[target.name as keyof LoginParams] = target.value;
            return v;
        });
    }
    async function performLogin(evt) {
        evt.preventDefault();
        setError('');
        console.log('state is', state);
        const result = await doLogin(state);
        console.log('result is', result);
        if (result?.data?.login?.error) {
            setError(result.data?.login?.error);
            return;
        }
        if (!result?.data?.login) {
            setError('Email or password is incorrect.');
            return;
        }
        siteData.siteData?.sites?.forEach((theatre)=>{
            if (theatre?.phoneRole == state.role) {
                siteData.setSite(theatre?.theatre??'');
            }
        });

        setUser(result.data?.login);
        navigate('/internal/search');
    }
    console.log('SD',siteData);
    function handleClickShowPassword() {
        setShowPassword((v)=>!v);
    }
    return (<Container maxWidth="md">
        <Grid container spacing={8}>
            <Grid item xs={12} md={6}>
                <Typography typography="h1" color="primary">{page.title}</Typography>
                <Typography typography="subtitle" color="primary">{page.subtitle}</Typography>
                <Divider sx={
                    (theme)=>({
                        paddingTop:theme.spacing(4)
                    })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <form onSubmit={performLogin}>
                {!!error &&
                  <Alert severity="error" sx={(theme)=>({borderRadius: 0, marginBottom:theme.spacing(2)})}>{error}</Alert>
                }
                <TextField type="username" required={true} value={state.username} name="username" label="Username" fullWidth={true} variant="standard" onChange={onChange}/>
                    <TextField name="password" required={true} value={state.password} label="Password" fullWidth={true} variant="standard" onChange={onChange}
                               InputProps={{endAdornment:
                                       <InputAdornment position="end">
                                           <IconButton
                                               aria-label="toggle password visibility"
                                               onClick={handleClickShowPassword}
                                               edge="end"
                                           >{showPassword ? <VisibilityOff /> : <Visibility />}
                                           </IconButton>
                                       </InputAdornment>,
                                   type:showPassword?'text':'password'
                               }}
                    />
                <FormControl variant="standard" fullWidth required >
                    <InputLabel shrink={!!state.role} id="role-label">Role</InputLabel>
                <Select name="role" labelId="role-label" variant="standard" onChange={onChange} value={state.role}>
                    {
                        siteData?.siteData?.sites?.sort((a,b)=>(a.label>b.label))?.map((theatre)=>(
                            <MenuItem key={theatre?.phoneRole} value={theatre?.phoneRole} >
                                <ListItemText>{theatre?.label}</ListItemText>
                            </MenuItem>)
                        )

                    }
                </Select>
                </FormControl>
                <Button color="secondary" disabled={loginResult.fetching||!state.role||!state.password||!state.username} startIcon={loginResult.fetching?<CircularProgress size="1rem"/>:null} sx={(theme)=>({marginTop:theme.spacing(3),marginBottom:theme.spacing(2)})} fullWidth={true} type="submit" variant="contained" size="large">{page.button}</Button>
                </form>
            </Grid>
        </Grid>
    </Container>);
}
export default InternalLoginPage;